import { render } from "./Box3d.vue?vue&type=template&id=bf4ce3ac"
import script from "./Box3d.vue?vue&type=script&lang=js"
export * from "./Box3d.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__